const PartnerInSuccess = () => {
    const benefits = [
        {
            title: "Zero Vendor Risk",
            description: "Eliminate the fear of scams or 'ghosting.' We are your verified, on-the-ground partner ensuring accountability."
        },
        {
            title: "Transparent Pricing",
            description: "No hidden fees. You get transparent pricing models so you can calculate your profit margins accurately."
        },
        {
            title: "On-Time, Every Time",
            description: "In business, timing is everything. We guarantee strict adherence to production schedules and delivery timelines."
        },
        {
            title: "Quality Guaranteed",
            description: "We don't just ship products; we ship reputation. Every item undergoes rigorous quality checks before it bears your logo."
        }
    ];

    return (
        <section className="w-full bg-white py-24 px-6 md:px-12">
            <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

                {/*  Left Column: Text Content  */}
                <div>
                    <h2 className="text-4xl md:text-5xl font-medium text-gray-900 mb-4 tracking-tight leading-tight">
                        Your Partner in <br className="hidden md:block" />
                        <span className='text-[#737373]'>

                            Sourcing and Success
                        </span>
                    </h2>
                    <p className="text-lg text-gray-500 mb-12">
                        Complete End-to-End Support for new entrepreneurs.
                    </p>

                    <div className="space-y-8">
                        {benefits.map((benefit, index) => (
                            <div key={index} className="flex items-start gap-4">
                                {/* Green Checkmark Icon */}
                                <div className="flex-shrink-0 mt-1">
                                    <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                                {/* Text */}
                                <div>
                                    <h3 className="text-xl font-medium text-gray-900 mb-2">{benefit.title}</h3>
                                    <p className="text-gray-500 leading-relaxed">
                                        {benefit.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/*Right Column: Image Grid */}
                <div className="grid grid-cols-2 gap-6">
                    {/* Top Left Image */}
                    <div className="aspect-[4/5] rounded-3xl overflow-hidden">
                        <img
                            src="./images/manwoman.png"
                            alt="Business partners looking at phone"
                            className="w-full h-full object-cover"
                        />
                    </div>

                    {/* Top Right Image */}
                    <div className="aspect-[4/5] rounded-3xl overflow-hidden">
                        <img
                            src="./images/delivery.png"
                            alt="Handing over a package"
                            className="w-full h-full object-cover"
                        />
                    </div>

                    {/* Bottom Wide Image */}
                    <div className="col-span-2 aspect-[16/9] rounded-3xl overflow-hidden">
                        <img
                            src="./images/warehouse.png"
                            alt="Shipping port with containers"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

            </div>
        </section>
    );
};

export default PartnerInSuccess;